import { PRODUCT_EVENT_CANONICAL_LEGACY_ACTION } from './productEventCanonicalLegacy';
import type { AmplitudeProductEventPayload } from './productEventPayloads';
import type { AmplitudeProductEventName } from './productEvents';
import {
  trackLegacyUserAction,
  type UserActionEnvelope,
} from './trackLegacyUserAction';

export type AmplitudeTrackSink = (
  eventType: string,
  eventProperties: Record<string, unknown>,
) => void;

/**
 * Hand bucket **(b)** instrumentation: call sites pass {@link AmplitudeProductEventName};
 * legacy `UserAction.action` and dual-emit are resolved in fe-shared.
 */
export const trackProductEvent = <E extends AmplitudeProductEventName>(
  track: AmplitudeTrackSink,
  productEvent: E,
  envelope: UserActionEnvelope,
  properties: AmplitudeProductEventPayload<E>,
  amplitudeAutocaptureEnabled: boolean,
): void => {
  const legacyAction = PRODUCT_EVENT_CANONICAL_LEGACY_ACTION[productEvent];
  trackLegacyUserAction(
    track,
    legacyAction,
    envelope,
    properties,
    amplitudeAutocaptureEnabled,
  );
};
